<template>
  <Header>
    <div slot='logo'>
      <Logo
      :showWhite="true"
      title="竞赛平台"
    />
    </div>
  </Header>
</template>

<script>
import Header from '@/components/Header'
import Logo from '@/components/Logo'
export default {
  components:{
    Header,
    Logo
  }
}
</script>

<style>

</style>